import { defineComponent as Q, ref as y, watch as W, onUnmounted as Z, createElementBlock as u, openBlock as l, Fragment as T, renderList as A, createElementVNode as g, normalizeClass as i, createBlock as ee, normalizeStyle as h, createCommentVNode as x, toDisplayString as M, Teleport as te } from "vue";
const ae = { class: "flex flex-col w-full gap-3" }, ne = ["onMouseenter", "onMouseleave", "aria-label", "aria-disabled", "aria-readonly", "aria-valuemin", "aria-valuemax", "aria-valuenow", "aria-valuetext"], oe = ["innerHTML"], re = {
  key: 2,
  class: "absolute inset-0 pointer-events-none"
}, le = { class: "bg-gray-900 text-white px-2 py-1 rounded shadow-lg text-sm whitespace-nowrap" }, se = ["id", "value", "min", "max", "step", "disabled", "readonly", "onInput", "onChange", "onKeydown", "onMouseenter", "onMouseleave"], ue = ["id", "onMousedown", "onTouchstart", "onKeydown", "onMouseenter", "onMouseleave", "tabindex", "aria-label", "aria-disabled", "aria-readonly", "aria-valuemin", "aria-valuemax", "aria-valuenow", "aria-valuetext"], ce = /* @__PURE__ */ Q({
  __name: "Slider",
  props: {
    items: {
      type: Array,
      required: !0,
      default: () => []
    }
  },
  emits: ["updateValue"],
  setup(R, { emit: B }) {
    const c = {
      /**
       * 将数值转换为指定精度的整数表示，避免浮点数精度问题
       * @param value 原始值
       * @param precision 精度（小数位数）
       * @returns 转换后的整数表示
       */
      toInteger(t, n) {
        const e = Math.pow(10, n);
        return Math.round(t * e);
      },
      /**
       * 将整数表示转换回浮点数
       * @param intValue 整数表示
       * @param precision 精度（小数位数）
       * @returns 转换后的浮点数
       */
      fromInteger(t, n) {
        const e = Math.pow(10, n);
        return t / e;
      },
      /**
       * 高精度加法
       * @param a 第一个数
       * @param b 第二个数
       * @param precision 精度
       * @returns 结果
       */
      add(t, n, e) {
        const a = this.toInteger(t, e), o = this.toInteger(n, e);
        return this.fromInteger(a + o, e);
      },
      /**
       * 高精度减法
       * @param a 被减数
       * @param b 减数
       * @param precision 精度
       * @returns 结果
       */
      subtract(t, n, e) {
        const a = this.toInteger(t, e), o = this.toInteger(n, e);
        return this.fromInteger(a - o, e);
      },
      /**
       * 高精度乘法
       * @param a 第一个数
       * @param b 第二个数
       * @param precision 精度
       * @returns 结果
       */
      multiply(t, n, e) {
        const a = this.toInteger(t, e), o = this.toInteger(n, e), r = Math.pow(10, e);
        return a * o / (r * r);
      },
      /**
       * 高精度除法
       * @param a 被除数
       * @param b 除数
       * @param precision 精度
       * @returns 结果
       */
      divide(t, n, e) {
        if (n === 0) return 0;
        const a = this.toInteger(t, e), o = this.toInteger(n, e);
        return a / o;
      },
      /**
       * 高精度四舍五入到指定精度
       * @param value 原始值
       * @param precision 精度
       * @returns 结果
       */
      round(t, n) {
        const e = this.toInteger(t, n);
        return this.fromInteger(e, n);
      },
      /**
       * 获取数值的有效精度（基于步长）
       * @param step 步长
       * @returns 精度位数
       */
      getPrecisionFromStep(t) {
        if (t >= 1) return 0;
        const n = t.toString();
        if (n.indexOf(".") !== -1) {
          const e = n.split(".")[1];
          return e ? e.length : 0;
        }
        if (n.indexOf("e-") !== -1) {
          const a = n.split("e-")[1];
          return a ? parseInt(a, 10) : 0;
        }
        return 0;
      }
    }, p = R, v = B, m = y(/* @__PURE__ */ new Map()), k = y(/* @__PURE__ */ new Map()), V = y(/* @__PURE__ */ new Set()), d = y(null), S = (t) => {
      const n = t.value;
      let e = t.precision !== void 0 ? t.precision : 0;
      e === 0 && t.step && t.step < 1 && (e = c.getPrecisionFromStep(t.step));
      const a = c.round(n, e);
      return e > 0 ? a.toFixed(e) : a.toString();
    }, b = (t, n) => {
      if (n.step === void 0 || n.step <= 0)
        return t;
      const e = n.step, a = n.min;
      let o = n.precision !== void 0 ? n.precision : c.getPrecisionFromStep(e);
      const r = c.subtract(t, a, o), s = c.round(c.divide(r, e, o), 0) * e, f = c.add(a, s, o);
      return Math.max(n.min, Math.min(n.max, f));
    }, C = (t, n) => {
      const e = n.target, a = p.items.find((o) => o.id === t);
      if (a) {
        let o = Number(e.value);
        o = b(o, a), a.liveUpdate !== !1 && v("updateValue", { id: t, value: o });
      }
    }, U = (t, n) => {
      const e = n.target, a = p.items.find((o) => o.id === t);
      if (a && a.liveUpdate === !1) {
        let o = Number(e.value);
        o = b(o, a), v("updateValue", { id: t, value: o });
      }
    }, Y = (t, n) => {
      const e = p.items.find((r) => r.id === t);
      if (!e || !e.keyboardSupport)
        return;
      let a = e.value;
      const o = e.step || 1;
      switch (n.key) {
        case "ArrowLeft":
        case "ArrowDown":
          a = Math.max(e.min, a - o);
          break;
        case "ArrowRight":
        case "ArrowUp":
          a = Math.min(e.max, a + o);
          break;
        case "Home":
          a = e.min;
          break;
        case "End":
          a = e.max;
          break;
        case "PageDown":
          a = Math.max(e.min, a - o * 10);
          break;
        case "PageUp":
          a = Math.min(e.max, a + o * 10);
          break;
        default:
          return;
      }
      n.preventDefault(), a = b(a, e), v("updateValue", { id: t, value: a });
    }, D = (t) => {
      const n = t.min, e = t.max;
      let o = (t.value - n) / (e - n) * 100;
      return t.reverse && (o = 100 - o), o;
    }, F = (t) => t.vertical ? {
      backgroundImage: `
        repeating-linear-gradient(0deg, rgba(255, 255, 255, 0.5) 0, rgba(255, 255, 255, 0.5) 1px, transparent 1px, transparent 10%),
        repeating-linear-gradient(0deg, rgba(255, 255, 255, 0.3) 0, rgba(255, 255, 255, 0.3) 1px, transparent 1px, transparent 2%)
      `,
      backgroundSize: "8px 100%, 5px 100%",
      backgroundPosition: "top left, top left",
      backgroundRepeat: "no-repeat"
    } : {
      backgroundImage: `
      repeating-linear-gradient(90deg, rgba(255, 255, 255, 0.5) 0, rgba(255, 255, 255, 0.5) 1px, transparent 1px, transparent 10%),
      repeating-linear-gradient(90deg, rgba(255, 255, 255, 0.3) 0, rgba(255, 255, 255, 0.3) 1px, transparent 1px, transparent 2%)
    `,
      backgroundSize: "100% 8px, 100% 5px",
      backgroundPosition: "top left, top left",
      backgroundRepeat: "no-repeat"
    }, K = (t, n) => {
      let e = (n.value - t.min) / (t.max - t.min) * 100;
      return t.reverse && (e = 100 - e), t.vertical ? {
        bottom: `${e}%`,
        left: "50%",
        ...n.style
      } : {
        left: `${e}%`,
        top: "50%",
        ...n.style
      };
    }, O = (t) => {
      const n = D(t);
      return t.vertical ? {
        bottom: `${n}%`
      } : {
        left: `${n}%`
      };
    }, H = (t) => t.tooltipFormatter ? t.tooltipFormatter(t.value, t.label) : `${t.label}: ${t.value}`, N = (t) => {
      const n = D(t), e = t.tooltipPosition || "top", a = {}, o = document.getElementById(t.id);
      if (o) {
        const r = o.getBoundingClientRect(), s = window.pageYOffset || document.documentElement.scrollTop, f = window.pageXOffset || document.documentElement.scrollLeft;
        e === "top" ? (a.left = `${r.left + f + r.width * n / 100}px`, a.top = `${r.top + s - 8}px`, a.transform = "translateX(-50%) translateY(-100%)") : e === "bottom" ? (a.left = `${r.left + f + r.width * n / 100}px`, a.top = `${r.top + s + r.height + 8}px`, a.transform = "translateX(-50%)") : e === "left" ? (a.left = `${r.left + f + r.width * n / 100 - 8}px`, a.top = `${r.top + s + r.height / 2}px`, a.transform = "translateX(-100%) translateY(-50%)") : e === "right" && (a.left = `${r.left + f + r.width * n / 100 + 8}px`, a.top = `${r.top + s + r.height / 2}px`, a.transform = "translateY(-50%)");
      }
      return a;
    }, I = (t) => {
      V.value.add(t);
    }, E = (t) => {
      V.value.delete(t);
    };
    W(
      () => p.items,
      (t) => {
        t.forEach((n) => {
          const e = m.value.get(n.id);
          e && e.value !== String(n.value) && (e.value = String(n.value));
        });
      },
      { deep: !0 }
    );
    const X = (t, n) => {
      n ? m.value.set(t, n) : m.value.delete(t);
    }, j = (t, n) => {
      n ? k.value.set(t, n) : k.value.delete(t);
    }, w = (t, n) => {
      const e = k.value.get(t.id);
      if (!e) return t.value;
      const a = e.getBoundingClientRect(), o = n - a.top, r = Math.max(0, Math.min(1, 1 - o / a.height));
      let s = t.precision !== void 0 ? t.precision : 0;
      s === 0 && t.step && t.step < 1 && (s = c.getPrecisionFromStep(t.step));
      const f = c.subtract(t.max, t.min, s);
      let P = c.add(t.min, c.multiply(r, f, s), s);
      return P = b(P, t), Math.max(t.min, Math.min(t.max, P));
    }, q = (t, n) => {
      const e = p.items.find((o) => o.id === t);
      if (!e || e.disabled || e.readonly) return;
      n.preventDefault(), d.value = t;
      const a = w(e, n.clientY);
      v("updateValue", { id: t, value: a }), document.addEventListener("mousemove", z), document.addEventListener("mouseup", _);
    }, G = (t, n) => {
      const e = p.items.find((o) => o.id === t);
      if (!e || e.disabled || e.readonly) return;
      n.preventDefault(), d.value = t;
      const a = n.touches[0];
      if (a) {
        const o = w(e, a.clientY);
        v("updateValue", { id: t, value: o });
      }
      document.addEventListener("touchmove", L, { passive: !1 }), document.addEventListener("touchend", $);
    }, z = (t) => {
      if (!d.value) return;
      const n = p.items.find((a) => a.id === d.value);
      if (!n) return;
      const e = w(n, t.clientY);
      v("updateValue", { id: d.value, value: e });
    }, L = (t) => {
      if (!d.value) return;
      t.preventDefault();
      const n = p.items.find((a) => a.id === d.value);
      if (!n) return;
      const e = t.touches[0];
      if (e) {
        const a = w(n, e.clientY);
        v("updateValue", { id: d.value, value: a });
      }
    }, _ = () => {
      d.value = null, document.removeEventListener("mousemove", z), document.removeEventListener("mouseup", _);
    }, $ = () => {
      d.value = null, document.removeEventListener("touchmove", L), document.removeEventListener("touchend", $);
    }, J = (t, n) => {
      const e = p.items.find((r) => r.id === t);
      if (!e || !e.keyboardSupport || e.disabled || e.readonly)
        return;
      let a = e.value;
      const o = e.step || 1;
      switch (n.key) {
        case "ArrowUp":
          a = Math.min(e.max, a + o);
          break;
        case "ArrowDown":
          a = Math.max(e.min, a - o);
          break;
        case "Home":
          a = e.max;
          break;
        case "End":
          a = e.min;
          break;
        case "PageUp":
          a = Math.min(e.max, a + o * 10);
          break;
        case "PageDown":
          a = Math.max(e.min, a - o * 10);
          break;
        default:
          return;
      }
      n.preventDefault(), a = b(a, e), v("updateValue", { id: t, value: a });
    };
    return Z(() => {
      document.removeEventListener("mousemove", z), document.removeEventListener("mouseup", _), document.removeEventListener("touchmove", L), document.removeEventListener("touchend", $);
    }), (t, n) => (l(), u("div", ae, [
      (l(!0), u(T, null, A(R.items, (e) => (l(), u("div", {
        key: e.id,
        class: "w-full"
      }, [
        g("div", {
          class: i(["relative rounded-lg overflow-hidden bg-[#333] group", {
            "w-full h-9": !e.vertical,
            "h-48 w-9": e.vertical,
            "opacity-50 cursor-not-allowed": e.disabled,
            "cursor-ew-resize": !e.disabled && !e.vertical,
            "cursor-ns-resize": !e.disabled && e.vertical
          }]),
          onMouseenter: () => I(e.id),
          onMouseleave: () => E(e.id),
          "aria-label": e.ariaLabel || e.label,
          "aria-disabled": e.disabled,
          "aria-readonly": e.readonly,
          "aria-valuemin": e.min,
          "aria-valuemax": e.max,
          "aria-valuenow": e.value,
          "aria-valuetext": `${e.label}: ${S(e)}`
        }, [
          g("div", {
            class: i(["absolute inset-0 z-10", { "w-full h-full": !e.vertical, "h-full w-full": e.vertical }]),
            style: h({ background: e.gradient })
          }, [
            e.backgroundSvg ? (l(), u("div", {
              key: 0,
              class: "absolute inset-0 opacity-50 pointer-events-none",
              innerHTML: e.backgroundSvg
            }, null, 8, oe)) : x("", !0),
            e.showRuler ? (l(), u("div", {
              key: 1,
              class: i(["absolute inset-0 pointer-events-none opacity-0 transition-opacity duration-200 ease-in-out", {
                "opacity-100": e.showRuler && e.rulerMode === "always",
                "group-hover:opacity-100": e.showRuler && e.rulerMode === "hover"
              }]),
              style: h(F(e))
            }, null, 6)) : x("", !0),
            e.marks && e.marks.length > 0 ? (l(), u("div", re, [
              (l(!0), u(T, null, A(e.marks, (a) => (l(), u("div", {
                key: a.value,
                class: i(["absolute w-2 h-2 bg-white rounded-full transform -translate-x-1/2 -translate-y-1/2", { "w-1 h-1": e.size === "small", "w-3 h-3": e.size === "large" }]),
                style: h(K(e, a))
              }, [
                a.label ? (l(), u("span", {
                  key: 0,
                  class: i(["absolute text-xs text-white whitespace-nowrap", {
                    "top-4 left-1/2 transform -translate-x-1/2": !e.vertical,
                    "left-4 top-1/2 transform -translate-y-1/2": e.vertical
                  }]),
                  style: h(a.style)
                }, M(a.label), 7)) : x("", !0)
              ], 6))), 128))
            ])) : x("", !0),
            g("div", {
              class: i(["absolute bg-white/90 pointer-events-none z-20", {
                "top-0 bottom-0 w-0.5 -translate-x-1/2": !e.vertical,
                "left-0 right-0 h-0.5 -translate-y-1/2": e.vertical
              }]),
              style: h(O(e))
            }, null, 6)
          ], 6),
          g("div", {
            class: i(["absolute inset-0 flex justify-between items-center px-3 z-30 pointer-events-none box-border", {
              "w-full h-full flex-row": !e.vertical,
              "h-full w-full flex-col": e.vertical
            }])
          }, [
            g("span", {
              class: i(["text-sm font-medium text-white/90", { "text-xs": e.size === "small", "text-base": e.size === "large" }]),
              style: { "text-shadow": "0 1px 2px rgba(0,0,0,0.6)" }
            }, M(e.label), 3),
            g("span", {
              class: i(["font-semibold font-mono text-white/90", { "text-sm": e.size === "small", "text-lg": e.size === "large", "text-base": !e.size || e.size === "medium" }]),
              style: { "text-shadow": "0 1px 2px rgba(0,0,0,0.6)" }
            }, M(S(e)), 3)
          ], 2),
          (l(), ee(te, { to: "body" }, [
            e.showTooltip ? (l(), u("div", {
              key: 0,
              class: i(["absolute z-[200] pointer-events-none transition-opacity duration-200 ease-in-out opacity-0", {
                "opacity-100": e.tooltipMode === "always" || V.value.has(e.id)
              }]),
              style: h(N(e))
            }, [
              g("div", le, M(H(e)), 1)
            ], 6)) : x("", !0)
          ])),
          e.vertical ? (l(), u("div", {
            key: 1,
            id: e.id,
            class: i(["absolute inset-0 opacity-0 z-[100] m-0 p-0", {
              "h-full w-full": e.vertical,
              "cursor-not-allowed": e.disabled,
              "cursor-ns-resize": !e.disabled && e.vertical
            }]),
            ref_for: !0,
            ref: (a) => j(e.id, a),
            onMousedown: (a) => q(e.id, a),
            onTouchstart: (a) => G(e.id, a),
            onKeydown: (a) => J(e.id, a),
            onMouseenter: () => I(e.id),
            onMouseleave: () => E(e.id),
            tabindex: e.disabled || e.readonly ? -1 : 0,
            "aria-label": e.ariaLabel || e.label,
            "aria-disabled": e.disabled,
            "aria-readonly": e.readonly,
            "aria-valuemin": e.min,
            "aria-valuemax": e.max,
            "aria-valuenow": e.value,
            "aria-valuetext": `${e.label}: ${S(e)}`
          }, null, 42, ue)) : (l(), u("input", {
            key: 0,
            id: e.id,
            value: e.value,
            type: "range",
            class: i(["absolute inset-0 opacity-0 z-[100] m-0 p-0", {
              "w-full h-full": !e.vertical,
              "cursor-not-allowed": e.disabled,
              "cursor-ew-resize": !e.disabled && !e.vertical
            }]),
            min: e.min,
            max: e.max,
            step: e.step || 1,
            disabled: e.disabled,
            readonly: e.readonly,
            ref_for: !0,
            ref: (a) => X(e.id, a),
            onInput: (a) => C(e.id, a),
            onChange: (a) => U(e.id, a),
            onKeydown: (a) => Y(e.id, a),
            onMouseenter: () => I(e.id),
            onMouseleave: () => E(e.id)
          }, null, 42, se))
        ], 42, ne)
      ]))), 128))
    ]));
  }
}), de = {
  /**
   * 显示在滑块前面
   */
  Before: "before",
  /**
   * 显示在滑块后面
   */
  After: "after",
  /**
   * 显示在滑块内部靠左
   */
  InsideLeft: "inside-left",
  /**
   * 显示在滑块内部居中
   */
  InsideCenter: "inside-center",
  /**
   * 显示在滑块内部靠右
   */
  InsideRight: "inside-right"
};
export {
  ce as Slider,
  de as SliderValuePosition,
  ce as default
};
